<template>
	<div>
		<div style="height: 20px;"></div>
		
		<div style="width: 300px; margin: 0 auto;">
			<img style="width: 100%;" src="https://school-saas.oss-cn-hangzhou.aliyuncs.com/files/2021-6-17/162389287238942.png?s=430_430" />
			<div style="text-align: center; padding-top: 50px;">请使用微信扫码完善个人信息</div>
		</div>
		
		<div v-if="false" style="width: 600px; border: 1px solid #ccc; margin: 0 auto; padding: 20px; border-radius: 4px;">
			<el-form :model="formData" ref="formData" label-width="120px">
				<el-row>
					<div style="text-align: center;">
						<h2>{{schoolname}}</h2>
					</div>
				</el-row>
				<el-row :gutter="20">

					<el-col :span="16">
						<el-form-item label="学生姓名:" prop="stu_name">
							<el-input type="text" size="small" v-model.trim="formData.stu_name" style="width: 100%"
								placeholder="请输入姓名" />
						</el-form-item>
					</el-col>
					<el-col :span="16">
						<el-form-item label="录取编号:" prop="stu_code">
							<el-input size="small" type="text" v-model.trim="formData.stu_code" style="width: 100%"
								placeholder="请输入录取编号" />
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="24" style="text-align: center;">
						<el-button type="primary" icon="el-icon-search" @click="searchStu">查询</el-button>
					</el-col>
				</el-row>


			</el-form>
		</div>

		<div style="height: 20px;"></div>
		<div v-if="EditItem.id" style="width: 600px; border: 1px solid #ccc; margin: 0 auto; padding: 20px;">
			<el-form :model="EditItem" ref="EditItem" :rules="rules" label-width="130px">
				<el-row>
					<el-col :span="24">
						<el-form-item label="学生信息:" style="color: #007AFF;">
							<div>
								姓名：{{EditItem.stu_name}}
							</div>
							<div>
								专业：{{EditItem.yuanxi_name?EditItem.yuanxi_name:''}}
								{{EditItem.major_name?'，'+EditItem.major_name:''}}
								{{EditItem.xuezhi?'，'+EditItem.xuezhi:''}}

								<div>
									班级：{{EditItem.class_name?EditItem.class_name:'未分班'}}
								</div>
								<div v-if="EditItem.bzr">
									班主任：{{EditItem.bzr?EditItem.bzr.username:''}}
									&nbsp;&nbsp;{{EditItem.bzr?EditItem.bzr.phone:''}}
								</div>
							</div>


						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="身份证号:" prop="identity_card">
							<el-input type="text" size="small" v-model.trim="EditItem.identity_card" style="width: 90%"
								placeholder="请输入身份证号" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="民族:" prop="minzu">
							<el-input type="text" size="small" v-model.trim="EditItem.minzu" style="width: 90%"
								placeholder="请输入民族" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="政治面貌:" prop="zzmm">

							<el-radio-group v-model="EditItem.zzmm">
								<el-radio label="团员">团员</el-radio>
								<el-radio label="群众">群众</el-radio>

							</el-radio-group>

						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="籍贯:" prop="jiguan">
							<el-input type="text" size="small" v-model.trim="EditItem.jiguan" style="width: 90%"
								placeholder="请输入籍贯" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="户口所在地:" prop="hkszd">
							<el-input type="text" size="small" v-model.trim="EditItem.hkszd" style="width: 90%"
								placeholder="请输入户口所在地" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="户口所在派出所:" prop="hkszdpcs">
							<el-input type="text" size="small" v-model.trim="EditItem.hkszdpcs" style="width: 90%"
								placeholder="请输入户口所在派出所" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="户口性质:" prop="hkxz">
							<el-radio-group v-model="EditItem.hkxz">
								<el-radio label="非农业户口">非农业户口</el-radio>
								<el-radio label="农业户口">农业户口</el-radio>

							</el-radio-group>

						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="居住地类型:" prop="jzdtype">
							<el-radio-group v-model="EditItem.jzdtype">
								<el-radio :label="item" v-for="(item,idx) in jzdtypes" :key="idx">{{item}}</el-radio>


							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="家庭住址:" prop="jtzz">
							<el-input type="text" size="small" v-model.trim="EditItem.jtzz" style="width: 90%"
								placeholder="请输入家庭住址" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="监护人姓名:" prop="jhr1name">
							<el-input type="text" size="small" v-model.trim="EditItem.jhr1name" style="width: 90%"
								placeholder="请输入监护人姓名" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="监护人电话:" prop="jhr1phone">
							<el-input type="text" size="small" v-model.trim="EditItem.jhr1phone" style="width: 90%"
								placeholder="请输入监护人联系电话" />
						</el-form-item>
					</el-col>

				</el-row>


				<el-row>
					<el-col :span="24" style="text-align: center;">
						<el-button v-if="!saveok" type="primary" icon="el-icon-document-checked" @click="saveStu">保存个人信息
						</el-button>
					</el-col>
				</el-row>



			</el-form>




		</div>
		<div style="height: 100px;"></div>
	</div>
</template>

<script>
	export default {
		data() {

			return {
				logo2: "",
				schoolname: "",
				formData: {
					stu_code: "",
					stu_name: ""
				},
				EditItem: {
					id: 0,
					identity_card: '',
					minzu: '',
					zzmm: '',
					jiguan: '',
					hkszd: '',
					hkszdpcs: '',
					hkxz: '',
					jzdtype: '',
					jtzz: '',
					jhr1name: '',
					jhr1phone: '',
					jhr2name: '',
					jhr2phone: '',
					openid: ""
				},

				rules: {
					identity_card: [{
							required: true,
							message: '请输入证件号',
							trigger: 'blur'
						},
						{
							pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
							message: '请输入正确的证件号',
							trigger: 'blur'
						},

					],
					minzu: [{
						required: true,
						message: '请输入民族',
						trigger: 'blur'
					}, ],
					zzmm: [{
						required: true,
						message: '请选择政治面貌',
						trigger: 'blur'
					}, ],
					jiguan: [{
						required: true,
						message: '请输入籍贯',
						trigger: 'blur'
					}, ],

					hkszd: [{
						required: true,
						message: '请输入户口所在地',
						trigger: 'blur'
					}, ],

					hkxz: [{
						required: true,
						message: '请选择户口性质',
						trigger: 'blur'
					}, ],
					jzdtype: [{
						required: true,
						message: '请选择居住地类型',
						trigger: 'blur'
					}, ],
					jtzz: [{
						required: true,
						message: '请输入家庭住址',
						trigger: 'blur'
					}, ],
					jhr1name: [{
						required: true,
						message: '请输入监护人姓名',
						trigger: 'blur'
					}, ],
					jhr1phone: [{
						required: true,
						message: '请输入监护人联系电话',
						trigger: 'blur'
					}, ],

				},
				city: ["江苏省", "南京市", ""],
				jzdtypes: ['农村', '乡镇非农', '城市', '县城'],
				loading: false,
				saveok: false
			}
		},
		mounted() {
			document.title="请扫码完善信息"
			//this.getConfig()
			// this.$http.post("/api/get_mini_token", {
			// 	pmid:1
			// })


		},
		methods: {
			getConfig() {
				this.$http.post("/api/platform_settings", {
					pmid: window.pmid
				}).then(res => {
					for (let item of res.data) {
						if (item.ktype == 'logo2') {
							this.logo2 = item.kvalue;
						}
						if (item.ktype == 'schoolname') {
							document.title = "欢迎登录" + item.kvalue + "招生系统"
							this.schoolname = item.kvalue
						}
						//首页图标
						if (item.ktype == 'favicon' || item.ktype == 'favico') {
							var link = document.createElement('link');
							link.type = 'image/x-icon';
							link.rel = 'shortcut icon';
							link.href = item.kvalue;
							document.getElementsByTagName('head')[0].appendChild(link);
						}
					}
					//this.searchStu()
				})
			},
			searchStu() {
				if (this.formData.stu_code && this.formData.stu_name) {



					this.$http.post("/api/app_luqu_check", {
						stu_code: this.formData.stu_code,
						stu_name: this.formData.stu_name,
						pmid: window.pmid
					}).then(res => {
						if (!res.data) {
							this.$message.error("未找到录取信息")
						} else {
							if (res.data.stu_name == this.formData.stu_name) {
								this.$http.post("/api/stu_luqu_detail", {
									stu_id: res.data.id,
									pmid: window.pmid
								}).then(stu => {
									this.EditItem = stu.data
								})
							} else {
								this.$message.error("该学生姓名有误，请核实后再试~")
							}
						}
					})
				} else {
					this.$message.error("请输入完整！")
				}
			},
			saveStu() {
				if (this.loading) {

					return
				}
				this.$refs['EditItem'].validate((valid) => {
					if (valid) {
						this.loading = true
						setTimeout(() => {
							this.loading = false
						}, 3000)


						this.EditItem.uid = this.EditItem.id
						this.$http.post("/api/upd_student_fromweb", this.EditItem).then(res => {
							if (res.data) {

								this.$message.success("更新成功！")
								this.saveok = true
							}
						})

					}
				});
			}
		}
	}
</script>

<style scoped="scoped">
	.loginbtn {
		background: linear-gradient(to right, #258CFE, #1283FF);

		height: 90rpx;
		width: 100%;
		margin: 0 auto;
		position: relative;
		border-radius: 45rpx;
		text-align: center;
		line-height: 90rpx;
		color: #fff;
		font-weight: bold;
		font-size: 36rpx;
	}

	.shadowLine {
		width: calc(100% - 90rpx);
		height: 6px;
		margin: 0 auto;
		margin-top: -8px;
		box-shadow: 0 6px 4px 0px rgba(18, 131, 255, 0.5);
	}

	.useritem {
		width: 168rpx;
		height: 208rpx;
		display: inline-block;
		margin-right: 8rpx;
		margin-bottom: 20rpx;
		vertical-align: top;
	}

	.useritem:nth-child(3n) {
		margin-right: 0;
	}

	.userhead {
		width: 168rpx;
		height: 168rpx;
	}

	.userhead image {
		width: 100%;
		height: 100%;
		border-radius: 4px;
	}

	.nickname {
		height: 40rpx;
		width: 100%;
		overflow: hidden;
		line-height: 40rpx;
	}
</style>
